import { render, staticRenderFns } from "./LoaderWrapper.vue?vue&type=template&id=0aaddead&"
import script from "./LoaderWrapper.vue?vue&type=script&lang=js&"
export * from "./LoaderWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports